// The API case-converter camelCases permission-map object keys
// (user_management → userManagement) but leaves the feature `key` value
// snake_case. Use this to look up permissions by a feature's key.
export const camelizeFeatureKey = (key: string): string =>
  key.replace(/_([a-z])/g, (_match, char: string) => char.toUpperCase())

// Turns a permission-map key into a display label:
// `userManagement` → "User Management", `email` → "Email".
export const humanizeFeatureKey = (key: string): string =>
  key
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (char) => char.toUpperCase())
    .trim()
